import AdminHeader from '../components/common/AdminHeader';

export default function Reports() {
  return (
    <div className="min-h-screen bg-gray-50">
      <AdminHeader />
      <main className="max-w-7xl mx-auto px-4 sm:px-6 py-6 sm:py-8">
        <div className="bg-white rounded-xl shadow-sm border border-gray-200 p-6 sm:p-12">
          <div className="text-center">
            <h2 className="text-3xl font-bold text-gray-900 mb-4">Reports</h2>
            <p className="text-gray-600 text-lg">
              Reports module coming soon...
            </p>
          </div>
        </div>
      </main>
    </div>
  );
}
